/* eslint-disable max-lines */
import { defineMessages } from 'react-intl';

export default defineMessages({
  gym: {
    id: 'app.roomSuggestions.gym',
    defaultMessage: 'Academia',
  },
  heater: {
    id: 'app.roomSuggestions.heater',
    defaultMessage: 'Aquecedor',
  },
  airConditioner: {
    id: 'app.roomSuggestions.airConditioner',
    defaultMessage: 'Ar condicionado',
  },
  commomArea: {
    id: 'app.roomSuggestions.commomArea',
    defaultMessage: 'Área comum',
  },
  commomAreaGym: {
    id: 'app.roomSuggestions.commomAreaGym',
    defaultMessage: 'Área comum - Academia',
  },
  commomAreaGrill: {
    id: 'app.roomSuggestions.commomAreaGrill',
    defaultMessage: 'Área comum - Churrasqueira',
  },
  commomAreaPool: {
    id: 'app.roomSuggestions.commomAreaPool',
    defaultMessage: 'Área comum - Piscina',
  },
  commonAreaPlayground: {
    id: 'app.roomSuggestions.commonAreaPlayground',
    defaultMessage: 'Área comum - Playground',
  },
  commonAreaPartyHall: {
    id: 'app.roomSuggestions.commonAreaPartyHall',
    defaultMessage: 'Área comum - Salão de festas',
  },
  serviceArea: {
    id: 'app.roomSuggestions.serviceArea',
    defaultMessage: 'Área de Serviço',
  },
  externalArea: {
    id: 'app.roomSuggestions.externalArea',
    defaultMessage: 'Área externa',
  },
  gourmetArea: {
    id: 'app.roomSuggestions.gourmetArea',
    defaultMessage: 'Área gourmet',
  },
  bathroom: {
    id: 'app.roomSuggestions.bathroom',
    defaultMessage: 'Banheiro',
  },
  bathroomFaucet: {
    id: 'app.roomSuggestions.bathroomFaucet',
    defaultMessage: 'Banheiro - torneira',
  },
  bathroom1: {
    id: 'app.roomSuggestions.bathroom1',
    defaultMessage: 'Banheiro 1',
  },
  bathroom2: {
    id: 'app.roomSuggestions.bathroom2',
    defaultMessage: 'Banheiro 2',
  },
  hallBathroom: {
    id: 'app.roomSuggestions.hallBathroom',
    defaultMessage: 'Banheiro Corredor',
  },
  suiteBathroom: {
    id: 'app.roomSuggestions.suiteBathroom',
    defaultMessage: 'Banheiro da Suíte',
  },
  suiteBathroom1: {
    id: 'app.roomSuggestions.suiteBathroom1',
    defaultMessage: 'Banheiro da Suíte 1',
  },
  suiteBathroom2: {
    id: 'app.roomSuggestions.suiteBathroom2',
    defaultMessage: 'Banheiro da Suíte 2',
  },
  suiteBathroom3: {
    id: 'app.roomSuggestions.suiteBathroom3',
    defaultMessage: 'Banheiro da Suíte 3',
  },
  suiteBathroom4: {
    id: 'app.roomSuggestions.suiteBathroom4',
    defaultMessage: 'Banheiro da Suíte 4',
  },
  serviceBathroom: {
    id: 'app.roomSuggestions.serviceBathroom',
    defaultMessage: 'Banheiro de serviço',
  },
  roomBathroom1: {
    id: 'app.roomSuggestions.roomBathroom1',
    defaultMessage: 'Banheiro do Quarto 1',
  },
  roomBathroom2: {
    id: 'app.roomSuggestions.roomBathroom2',
    defaultMessage: 'Banheiro do Quarto 2',
  },
  roomBathroom3: {
    id: 'app.roomSuggestions.roomBathroom3',
    defaultMessage: 'Banheiro do Quarto 3',
  },
  socialBathroom: {
    id: 'app.roomSuggestions.socialBathroom',
    defaultMessage: 'Banheiro Social',
  },
  kidsRoom: {
    id: 'app.roomSuggestions.kidsRoom',
    defaultMessage: 'Brinquedoteca',
  },
  grill: {
    id: 'app.roomSuggestions.grill',
    defaultMessage: 'Churrasqueira',
  },
  shower: {
    id: 'app.roomSuggestions.shower',
    defaultMessage: 'Chuveiro',
  },
  closet: {
    id: 'app.roomSuggestions.closet',
    defaultMessage: 'Closet',
  },
  roomCloset: {
    id: 'app.roomSuggestions.roomCloset',
    defaultMessage: 'Closet do quarto',
  },
  roomCloset1: {
    id: 'app.roomSuggestions.roomCloset1',
    defaultMessage: 'Closet do quarto 1',
  },
  roomCloset2: {
    id: 'app.roomSuggestions.roomCloset2',
    defaultMessage: 'Closet do quarto 2',
  },
  roomCloset3: {
    id: 'app.roomSuggestions.roomCloset3',
    defaultMessage: 'Closet do quarto 3',
  },
  roomCloset4: {
    id: 'app.roomSuggestions.roomCloset4',
    defaultMessage: 'Closet do quarto 4',
  },
  suiteCloset: {
    id: 'app.roomSuggestions.suiteCloset',
    defaultMessage: 'Closet da suíte',
  },
  suiteCloset1: {
    id: 'app.roomSuggestions.suiteCloset1',
    defaultMessage: 'Closet da suíte 1',
  },
  suiteCloset2: {
    id: 'app.roomSuggestions.suiteCloset2',
    defaultMessage: 'Closet da suíte 2',
  },
  suiteCloset3: {
    id: 'app.roomSuggestions.suiteCloset3',
    defaultMessage: 'Closet da suíte 3',
  },
  suiteCloset4: {
    id: 'app.roomSuggestions.suiteCloset4',
    defaultMessage: 'Closet da suíte 4',
  },
  roof: {
    id: 'app.roomSuggestions.roof',
    defaultMessage: 'Cobertura',
  },
  condominium: {
    id: 'app.roomSuggestions.condominium',
    defaultMessage: 'Condomínio',
  },
  kitchenPantry: {
    id: 'app.roomSuggestions.kitchenPantry',
    defaultMessage: 'Copa',
  },
  hall: {
    id: 'app.roomSuggestions.hall',
    defaultMessage: 'Corredor',
  },
  kitchen: {
    id: 'app.roomSuggestions.kitchen',
    defaultMessage: 'Cozinha',
  },
  kitchenCabinets: {
    id: 'app.roomSuggestions.kitchenCabinets',
    defaultMessage: 'Cozinha - Armários',
  },
  kitchenFaucet: {
    id: 'app.roomSuggestions.kitchenFaucet',
    defaultMessage: 'Cozinha - Torneira',
  },
  kitchenAndServiceRoom: {
    id: 'app.roomSuggestions.kitchenAndServiceRoom',
    defaultMessage: 'Cozinha e Área de Serviço',
  },
  pantry: {
    id: 'app.roomSuggestions.pantry',
    defaultMessage: 'Despensa',
  },
  detail: {
    id: 'app.roomSuggestions.detail',
    defaultMessage: 'Detalhe',
  },
  serviceRoomDetail: {
    id: 'app.roomSuggestions.serviceRoomDetail',
    defaultMessage: 'Detalhe da area de serviço',
  },
  kitchenDetail2: {
    id: 'app.roomSuggestions.kitchenDetail2',
    defaultMessage: 'Detalhe da cozinha',
  },
  bathroomDetail2: {
    id: 'app.roomSuggestions.bathroomDetail2',
    defaultMessage: 'Detalhe do banheiro',
  },
  suiteBathroomDetail: {
    id: 'app.roomSuggestions.suiteBathroomDetail',
    defaultMessage: 'Detalhe do Banheiro da Suite',
  },
  livingRoomDetail: {
    id: 'app.roomSuggestions.livingRoomDetail',
    defaultMessage: 'Detalhe Sala',
  },
  shower2: {
    id: 'app.roomSuggestions.shower2',
    defaultMessage: 'Ducha',
  },
  building: {
    id: 'app.roomSuggestions.building',
    defaultMessage: 'Edifício',
  },
  entrance: {
    id: 'app.roomSuggestions.entrance',
    defaultMessage: 'Entrada',
  },
  stairs: {
    id: 'app.roomSuggestions.stairs',
    defaultMessage: 'Escada',
  },
  office: {
    id: 'app.roomSuggestions.office',
    defaultMessage: 'Escritório',
  },
  gourmetSpace: {
    id: 'app.roomSuggestions.gourmetSpace',
    defaultMessage: 'Espaço Gourmet',
  },
  facade: {
    id: 'app.roomSuggestions.facade',
    defaultMessage: 'Fachada',
  },
  blockFacade: {
    id: 'app.roomSuggestions.blockFacade',
    defaultMessage: 'Fachada do bloco',
  },
  condominiumFacade: {
    id: 'app.roomSuggestions.condominiumFacade',
    defaultMessage: 'Fachado do condomínio',
  },
  buildingFacade: {
    id: 'app.roomSuggestions.buildingFacade',
    defaultMessage: 'Fachada do Prédio',
  },
  facadeAndConcierge: {
    id: 'app.roomSuggestions.facadeAndConcierge',
    defaultMessage: 'Fachada e portaria',
  },
  garage: {
    id: 'app.roomSuggestions.garage',
    defaultMessage: 'Garagem',
  },
  hall2: {
    id: 'app.roomSuggestions.hall2',
    defaultMessage: 'Hall',
  },
  entranceHall: {
    id: 'app.roomSuggestions.entranceHall',
    defaultMessage: 'Hall de entrada',
  },
  socialHall: {
    id: 'app.roomSuggestions.socialHall',
    defaultMessage: 'Hall social',
  },
  garden: {
    id: 'app.roomSuggestions.garden',
    defaultMessage: 'Jardim',
  },
  kitnet: {
    id: 'app.roomSuggestions.kitnet',
    defaultMessage: 'Kitnet',
  },
  toilet: {
    id: 'app.roomSuggestions.toilet',
    defaultMessage: 'Lavabo',
  },
  laundry: {
    id: 'app.roomSuggestions.laundry',
    defaultMessage: 'Lavanderia',
  },
  laundryFaucet: {
    id: 'app.roomSuggestions.laundryFaucet',
    defaultMessage: 'Lavanderia (Torneira)',
  },
  sink: {
    id: 'app.roomSuggestions.sink',
    defaultMessage: 'Pia',
  },
  pool: {
    id: 'app.roomSuggestions.pool',
    defaultMessage: 'Piscina',
  },
  indoorPool: {
    id: 'app.roomSuggestions.indoorPool',
    defaultMessage: 'Piscina Coberta',
  },
  playground: {
    id: 'app.roomSuggestions.playground',
    defaultMessage: 'Playground',
  },
  court: {
    id: 'app.roomSuggestions.court',
    defaultMessage: 'Quadra',
  },
  sportsCourt: {
    id: 'app.roomSuggestions.sportsCourt',
    defaultMessage: 'Quadra Esportiva',
  },
  room: {
    id: 'app.roomSuggestions.room',
    defaultMessage: 'Quarto',
  },
  roomCabinets: {
    id: 'app.roomSuggestions.roomCabinets',
    defaultMessage: 'Quarto - Armários',
  },
  room1: {
    id: 'app.roomSuggestions.room1',
    defaultMessage: 'Quarto 1',
  },
  roomCabinets1: {
    id: 'app.roomSuggestions.roomCabinets1',
    defaultMessage: 'Quarto 1 - Armários',
  },
  room2: {
    id: 'app.roomSuggestions.room2',
    defaultMessage: 'Quarto 2',
  },
  suiteRoom2: {
    id: 'app.roomSuggestions.suiteRoom2',
    defaultMessage: 'Quarto 2 - Suíte',
  },
  roomCabinets2: {
    id: 'app.roomSuggestions.roomCabinets2',
    defaultMessage: 'Quarto 2 - Armários',
  },
  room3: {
    id: 'app.roomSuggestions.room3',
    defaultMessage: 'Quarto 3',
  },
  suiteRoom3: {
    id: 'app.roomSuggestions.suiteRoom3',
    defaultMessage: 'Quarto 3 - Suíte',
  },
  roomCabinets3: {
    id: 'app.roomSuggestions.roomCabinets3',
    defaultMessage: 'Quarto 3 - Armários',
  },
  room4: {
    id: 'app.roomSuggestions.room4',
    defaultMessage: 'Quarto 4',
  },
  suiteRoom4: {
    id: 'app.roomSuggestions.suiteRoom4',
    defaultMessage: 'Quarto 4 - Suíte',
  },
  roomCabinets4: {
    id: 'app.roomSuggestions.roomCabinets4',
    defaultMessage: 'Quarto 4 - Armários',
  },
  serviceRoom: {
    id: 'app.roomSuggestions.serviceRoom',
    defaultMessage: 'Quarto de Serviço',
  },
  suiteRoom: {
    id: 'app.roomSuggestions.suiteRoom',
    defaultMessage: 'Quarto Suíte',
  },
  backyard: {
    id: 'app.roomSuggestions.backyard',
    defaultMessage: 'Quintal',
  },
  balcony: {
    id: 'app.roomSuggestions.balcony',
    defaultMessage: 'Sacada',
  },
  livingRoom: {
    id: 'app.roomSuggestions.livingRoom',
    defaultMessage: 'Sala',
  },
  livingRoom1: {
    id: 'app.roomSuggestions.livingRoom1',
    defaultMessage: 'Sala 1',
  },
  livingRoom2: {
    id: 'app.roomSuggestions.livingRoom2',
    defaultMessage: 'Sala 2',
  },
  diningRoom: {
    id: 'app.roomSuggestions.diningRoom',
    defaultMessage: 'Sala de Jantar',
  },
  playroom: {
    id: 'app.roomSuggestions.playroom',
    defaultMessage: 'Sala de Jogos',
  },
  tvRoom: {
    id: 'app.roomSuggestions.tvRoom',
    defaultMessage: 'Sala de TV',
  },
  livingRoomAndKitchen: {
    id: 'app.roomSuggestions.livingRoomAndKitchen',
    defaultMessage: 'Sala/Cozinha',
  },
  LivingRoomAndRoom: {
    id: 'app.roomSuggestions.LivingRoomAndRoom',
    defaultMessage: 'Sala/Quarto',
  },
  partyHall2: {
    id: 'app.roomSuggestions.partyHall2',
    defaultMessage: 'Salão de Festas',
  },
  gameRoom: {
    id: 'app.roomSuggestions.gameRoom',
    defaultMessage: 'Salão de jogos',
  },
  steamRoom: {
    id: 'app.roomSuggestions.steamRoom',
    defaultMessage: 'Saúna',
  },
  spa: {
    id: 'app.roomSuggestions.spa',
    defaultMessage: 'Spa',
  },
  studio: {
    id: 'app.roomSuggestions.studio',
    defaultMessage: 'Studio',
  },
  suite: {
    id: 'app.roomSuggestions.suite',
    defaultMessage: 'Suíte',
  },
  suite1: {
    id: 'app.roomSuggestions.suite1',
    defaultMessage: 'Suíte 1',
  },
  suite2: {
    id: 'app.roomSuggestions.suite2',
    defaultMessage: 'Suíte 2',
  },
  suite3: {
    id: 'app.roomSuggestions.suite3',
    defaultMessage: 'Suíte 3',
  },
  suite4: {
    id: 'app.roomSuggestions.suite4',
    defaultMessage: 'Suíte 4',
  },
  masterSuite: {
    id: 'app.roomSuggestions.masterSuite',
    defaultMessage: 'Suíte master',
  },
  terrace: {
    id: 'app.roomSuggestions.terrace',
    defaultMessage: 'Terraço',
  },
  porch: {
    id: 'app.roomSuggestions.porch',
    defaultMessage: 'Varanda',
  },
  livingRoomPorch: {
    id: 'app.roomSuggestions.livingRoomPorch',
    defaultMessage: 'Varanda da Sala',
  },
  gourmetPorch: {
    id: 'app.roomSuggestions.gourmetPorch',
    defaultMessage: 'Varanda gourmet',
  },
  view: {
    id: 'app.roomSuggestions.view',
    defaultMessage: 'Vista',
  },
  streetView: {
    id: 'app.roomSuggestions.streetView',
    defaultMessage: 'Vista da Rua',
  },
  balconyView: {
    id: 'app.roomSuggestions.balconyView',
    defaultMessage: 'Vista da Sacada',
  },
  livingRoomView: {
    id: 'app.roomSuggestions.livingRoomView',
    defaultMessage: 'Vista da Sala',
  },
  suiteView: {
    id: 'app.roomSuggestions.suiteView',
    defaultMessage: 'Vista da Suíte',
  },
  porchView: {
    id: 'app.roomSuggestions.porchView',
    defaultMessage: 'Vista da Varanda',
  },
  roomView: {
    id: 'app.roomSuggestions.roomView',
    defaultMessage: 'Vista do Quarto',
  },
  roomView1: {
    id: 'app.roomSuggestions.roomView1',
    defaultMessage: 'Vista do Quarto 1',
  },
  roomView2: {
    id: 'app.roomSuggestions.roomView2',
    defaultMessage: 'Vista do Quarto 2',
  },
});
